var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92 20.94A12.76 12.76 0 0020.76 8.1v-.59A9.06 9.06 0 0023 5.18a9 9 0 01-2.59.71 4.52 4.52 0 002-2.5 9.18 9.18 0 01-2.86 1.1 4.51 4.51 0 00-7.81 3.08 4.93 4.93 0 00.11 1 12.82 12.82 0 01-9.3-4.71 4.45 4.45 0 00-.61 2.27 4.51 4.51 0 002 3.75 4.45 4.45 0 01-2.05-.56v.06a4.52 4.52 0 003.61 4.45 4.48 4.48 0 01-2 .08A4.5 4.5 0 007.68 17a9 9 0 01-5.6 2A9.51 9.51 0 011 18.91a12.79 12.79 0 006.92 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}

export default SvgTwitter;